import { createFileRoute } from '@tanstack/react-router'

import { AcademyCard } from '@/components/fotograf/profil'
import { JellyIcon } from '@/components/icons'
import { ProfileRow, SectionLabel } from '@/components/shared'
import { AppLink as Link } from '@/components/shell'
import { ACCOUNT_ROWS, TOMAS } from '@/mocks/fotograf/profil'

export const Route = createFileRoute('/fotograf/profil')({
  head: () => ({ meta: [{ title: 'Profil · Aplikace Bitez' }] }),
  component: FotografProfil,
})

function FotografProfil() {
  return (
    <div className="px-4 pt-6 pb-6">
      <header className="flex items-center gap-3.5">
        <img
          src={TOMAS.avatar}
          alt=""
          width={150}
          height={150}
          className="size-13 shrink-0 rounded-full object-cover shadow-sm ring-2 ring-white"
        />
        <div className="min-w-0">
          <SectionLabel>Profil</SectionLabel>
          {/* Reputation lives here and nowhere else — stars behind the name */}
          <h1 className="font-display mt-0.5 text-2xl leading-[0.9] uppercase">
            {TOMAS.name}
            <span
              aria-label={`Hodnocení ${TOMAS.stars} z 5`}
              className="ml-2.5 inline-flex gap-0.5 align-middle"
            >
              {Array.from({ length: TOMAS.stars }, (_, index) => (
                <JellyIcon
                  key={index}
                  name="star"
                  variant="fill"
                  className="size-3.5 text-sun-dark"
                />
              ))}
            </span>
          </h1>
        </div>
      </header>

      <div className="animate-rise-up mt-5">
        <AcademyCard done={6} total={8} note="Kodex chování, průběh shootu, práce se světlem." />
      </div>

      <div className="animate-rise-up mt-3 space-y-3" style={{ animationDelay: '60ms' }}>
        {/* Trend database (spec §12) — reading access, správce fills it */}
        <ProfileRow
          icon="fire"
          tone="brand"
          title="Databáze trendů"
          note="Co teď frčí v gastru — 3 nové tento měsíc"
        />
        {/* Payout mechanism is spec TODO #8 — the details live here either way */}
        <ProfileRow
          icon="file"
          title="Fakturační údaje"
          note="IČO, číslo účtu a doručovací adresa"
        />
        {/* Blocked list (spec §6.3) — respected when the rotation runs */}
        <ProfileRow
          icon="location-dot"
          title="Podniky, kam nejezdím"
          note="Zatím žádné — booking vám je nenabídne"
        />
      </div>

      <section className="mt-8 border-t border-ink/10 pt-4">
        <div className="space-y-1">
          {ACCOUNT_ROWS.map((row) => (
            <button
              key={row.label}
              type="button"
              className="flex w-full cursor-pointer items-center gap-2.5 rounded-2xl px-2 py-2.5 text-left text-sm font-semibold text-ink/70 transition-colors duration-150 hover:bg-white"
            >
              <JellyIcon name={row.icon} className="size-4 text-ink/45" />
              {row.label}
              <JellyIcon name="arrow-right" className="ml-auto size-3 text-ink/30" />
            </button>
          ))}
          <Link
            href="/prihlaseni"
            className="flex w-full cursor-pointer items-center gap-2.5 rounded-2xl px-2 py-2.5 text-left text-sm font-semibold text-brand transition-colors duration-150 hover:bg-white"
          >
            <JellyIcon name="arrow-right-from-bracket" className="size-4" />
            Odhlásit se
          </Link>
        </div>
      </section>
    </div>
  )
}
